import { ShareResponseError } from 'api';
import { useParams } from 'react-router-dom';

import { usePspViewShareDataQuery } from 'hooks';
import { getUserRole } from 'utils/getUserRole';

import { handleShareInfoSuccess } from './utils';
import { useMemo, useState } from 'react';

function getErrorText(responseBody?: ShareResponseError) {
    switch (responseBody?.status) {
        case 'LINK_EXPIRED':
            return 'This share has expired';
        default:
            return 'Something went wrong';
    }
}

export default function useSharePointCloudHandlers() {
    const [permissions, setPermissions] = useState<Record<any, any>>();
    const { pucKey } = useParams<{ pucKey: string }>();
    const { isError, error } = usePspViewShareDataQuery({
        pucKey: pucKey as string,
        queryOptions: {
            onSuccess(data) {
                const { permissions } = handleShareInfoSuccess(data.data);
                setPermissions(permissions);
            },
        },
    });

    const roleTitle = useMemo(() => getUserRole(permissions), [permissions]);

    const errorMsg = getErrorText(error?.response?.data);

    return { isError, errorMsg, roleTitle };
}
